module.exports = __webpack_public_path__ + "static/media/img_monitor-dashboard.0a644345.png";